/* KGT mixed-cart shipping acknowledgment; validates standard cart form checkout. */
(function () {
  function checkboxFor(el) {
    var drawer = el.closest('cart-drawer');
    var selector = drawer ? 'cart-drawer .kgt-mixed-shipping-confirm' : '#main-cart-items .kgt-mixed-shipping-confirm';
    return document.querySelector(selector);
  }
  function blockIfNeeded(event, el) {
    var box = checkboxFor(el);
    if (!box || box.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var message = box.closest('.kgt-shipping-acknowledgment').querySelector('.kgt-shipping-ack-error');
    if (message) message.hidden = false;
    box.setAttribute('aria-invalid', 'true');
    box.focus();
    box.scrollIntoView({behavior:'smooth',block:'center'});
  }
  document.addEventListener('click', function(event) {
    var button = event.target.closest('#checkout, #CartDrawer-Checkout, button[name="checkout"]');
    if (button) blockIfNeeded(event,button);
  },true);
  document.addEventListener('submit', function(event) {
    if (event.target.matches('#cart, #CartDrawer-Form')) blockIfNeeded(event,event.target);
  },true);
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.kgt-mixed-shipping-confirm')) return;
    if (event.target.checked) {
      var msg=event.target.closest('.kgt-shipping-acknowledgment').querySelector('.kgt-shipping-ack-error');
      if(msg) msg.hidden=true;
      event.target.removeAttribute('aria-invalid');
    }
  });
})();
